export const OAUTH_REDIRECT = `${window.location.origin}/oauth/callback`;

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;

export const googleAuthUrl = () => {
  const p = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: OAUTH_REDIRECT,
    response_type: "code",
    scope: "openid email profile",
    state: "google",
    prompt: "select_account",
    access_type: "online",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${p.toString()}`;
};

export const facebookAuthUrl = () => {
  const p = new URLSearchParams({
    client_id: FACEBOOK_APP_ID,
    redirect_uri: OAUTH_REDIRECT,
    response_type: "code",
    scope: "email,public_profile",
    state: "facebook",
  });
  return `https://www.facebook.com/v19.0/dialog/oauth?${p.toString()}`;
};

export const roleDest = (role) =>
  role === "talent" ? "/talent/settings" : role === "agency" ? "/agency/settings" : "/dashboard";
